'use client';
import { useState, useEffect } from 'react';
import Navigation from './Navigation';
import { useSearchParams } from 'next/navigation';
import { setMobileCookie } from '@/stores';
import { AuthTokenStorageService } from '@/lib/auth';

export default function Header() {
  const [isMobile, setIsMobile] = useState(
    AuthTokenStorageService.checkIsMobile() || false
  );
    const searchParams = useSearchParams();

  useEffect(() => {
    if (searchParams.get('isMobile') === '1') {
      setMobileCookie(true);
      setIsMobile(true);
    }
  }, [searchParams]);

  if (isMobile) {
    return null;
  }

  return (
    <div>
      <Navigation />
    </div>
  );
}
